import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
const BellFillIcon: FC = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g clipPath="url(#clip0_706_4133)"><path d="M14.25 18C14.25 19.245 13.245 20.25 12 20.25C10.755 20.25 9.75 19.245 9.75 18" fill="#5AF058" /><path d="M14.25 18C14.25 19.245 13.245 20.25 12 20.25C10.755 20.25 9.75 19.245 9.75 18" stroke="#1B1B1B" strokeWidth="1.5" strokeLinejoin="bevel" /><path d="M18.75 11.25V14.25L20.25 17.25H3.75L5.25 14.25V11.25C5.25 8.295 7.155 5.82 9.78 4.905C9.945 3.825 10.875 3 12 3C13.125 3 14.04 3.825 14.22 4.905C16.86 5.82 18.75 8.31 18.75 11.25Z" fill="#5AF058" /><path d="M18.75 11.25C18.75 8.295 16.845 5.82 14.22 4.905C14.055 3.825 13.125 3 12 3C10.875 3 9.96 3.825 9.78 4.905C7.14 5.82 5.25 8.31 5.25 11.25" stroke="#1B1B1B" strokeWidth="1.5" strokeMiterlimit="10" /><path d="M18.75 11.25V14.25L20.25 17.25H3.75L5.25 14.25V11.25" stroke="#1B1B1B" strokeWidth="1.5" strokeLinejoin="bevel" /><path d="M0 11.25H3" stroke="#1B1B1B" strokeWidth="1.5" strokeLinejoin="bevel" /><path d="M21 11.25H24" stroke="#1B1B1B" strokeWidth="1.5" strokeLinejoin="bevel" /><path d="M19.8003 6.75L22.3953 5.25" stroke="#1B1B1B" strokeWidth="1.5" strokeLinejoin="bevel" /><path d="M4.19973 6.75L1.60473 5.25" stroke="#1B1B1B" strokeWidth="1.5" strokeLinejoin="bevel" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<defs><clipPath id="clip0_706_4133"><rect width="24" height="24" fill="white" /></clipPath></defs></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default BellFillIcon;